var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllergenEgg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 20.5285C5 12.2401 10.7252 3 16.559 3C22.3789 3 28 12.2074 28 20.5285C28 26.3057 23.306 30 16.559 30C9.78686 30 5 26.2903 5 20.5285ZM26.4667 20.5285C26.4667 12.9414 21.3291 4.52608 16.559 4.52608C11.7684 4.52608 6.53334 12.9751 6.53334 20.5285C6.53334 25.3521 10.5616 28.4739 16.559 28.4739C22.5277 28.4739 26.4667 25.3738 26.4667 20.5285ZM16.4905 7.10887C16.8634 7.1035 17.3999 7.22053 18.0348 7.55527C19.0028 8.06567 19.9443 8.96796 20.8003 10.3386C21.6747 11.7387 22.4248 13.5753 23.0223 15.9C23.1272 16.3083 22.8797 16.7239 22.4695 16.8284C22.0593 16.9328 21.6417 16.6865 21.5368 16.2782C20.9761 14.0969 20.2846 12.4037 19.498 11.1442C18.7811 9.99627 18.0377 9.28381 17.317 8.90381C17.0194 8.7469 16.7861 8.67302 16.6354 8.64665L16.522 8.63459C16.0987 8.64667 15.7458 8.31497 15.7337 7.89373C15.7226 7.51078 15.9971 7.18565 16.365 7.12063L16.4905 7.10887Z",
    fill: "current",
    className: "filled",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergenEgg);
export default __webpack_public_path__ + "static/media/AllergenEgg.b48615c8.svg";
export { ForwardRef as ReactComponent };